import { Component, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { Constants } from '../../../constants';

/**
 * Generated class for the FichaPhotoModelPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ficha-photo-model',
  templateUrl: 'ficha-photo-model.html',
})
export class FichaPhotoModelPage {
  zoom: number = 1.5;
  image;
  @ViewChild('imagen') imagen: ElementRef;
  rotationAmount: number = 0;
  private ZOOM_MIN: number = .5;
  private ZOOM_MAX: number = 3;
  private ZOOM_STEP: number = .5;
  width: number;
  height: number;
  marginTop: number;
  marginLeft: number;
  maxWidth: number;
  maxHeight: number;
  deviceWidth: number;
  deviceHeight: number;
  diametro: number = 20;
  urlFoto: string = "";
  constructor(public navCtrl: NavController, public navParams: NavParams, platform: Platform) {
    //this.image = navParams.data.recipe.framePicture;
  
    this.urlFoto = Constants.urlFotos + navParams.data.idMedicion + '/download/modelo.jpeg'
   
    this.image = this.urlFoto;
    platform.ready().then((readySource) => {
      this.deviceWidth = platform.width();
      this.deviceHeight = platform.height();


    });
  }

  zoomOut() {
    console.log('zoom Out', this.zoom, this.marginTop, this.marginLeft)
    if (this.zoom == this.ZOOM_MIN) return
    this.zoom -= this.ZOOM_STEP;
    this.resizeImage(this.zoom);
  }

  zoomIn() {
    console.log('zoom Out', this.zoom, this.marginTop, this.marginLeft)
    if (this.zoom == this.ZOOM_MAX) return
    this.zoom += this.ZOOM_STEP;
    this.resizeImage(this.zoom);
  }
  ionViewDidLoad() {

    console.log(this.navParams.data);
  }
  ngAfterViewInit() {
    this.imagen.nativeElement.addEventListener('load', () => {
      console.log('load')
      this.resizeImage(this.zoom);
    });
  }


  resizeImage(zoom: number = 1) {
    console.log("NAT", this.imagen.nativeElement.naturalWidth, this.imagen.nativeElement.naturalHeight, this.deviceHeight, this.deviceWidth)
    this.width = this.imagen.nativeElement.naturalWidth * zoom;
    this.height = this.imagen.nativeElement.naturalHeight * zoom;
    this.marginTop = (this.deviceHeight - this.height) / 2;
    this.marginLeft = (this.deviceWidth - this.width) / 2;
    this.maxWidth = this.width;
    this.maxHeight = this.height;

    //  this.printImageSize();
  }

  public rotar(sense: number) {

    //1 = izq, 0 = der
    this.rotationAmount = (sense > 0) ? this.rotationAmount += -90 : this.rotationAmount += 90;

    var rotation = "rotate(" + this.rotationAmount + "deg)";
    this.imagen.nativeElement.style.transform = rotation;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ficha-tabs/ficha-photo-model/ficha-photo-model.ts